var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AAC3D7;}\r\n\t.st1{fill:#D7E6F0;}\r\n\t.st2{fill:#323232;}\r\n\t.st3{fill:#464646;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,496c-4.4,0-8-3.6-8-8V296c0-4.4-3.6-8-8-8s-8,3.6-8,8v192c0,4.4-3.6,8-8,8h-64c-4.4,0-8-3.6-8-8V272 c0-8.8,7.2-16,16-16h144c8.8,0,16,7.2,16,16v216c0,4.4-3.6,8-8,8H272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168,272v216c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8V296c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v192 c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8V272c0-8.8-7.2-16-16-16H184C175.2,256,168,263.2,168,272z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392,256c-4.4,0-8-3.6-8-8v-88l-24-24V32l81.9,81.9c9,9,14.1,21.3,14.1,33.9V248c0,4.4-3.6,8-8,8H392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.9,113.9L360,32v104l24,24v88c0,4.4,3.6,8,8,8h56c4.4,0,8-3.6,8-8V147.8 C456,135.1,450.9,122.9,441.9,113.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,256c-4.4,0-8-3.6-8-8V147.8c0-12.6,5.1-24.9,14.1-33.9L152,32v104l-24,24v88c0,4.4-3.6,8-8,8H64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,147.8V248c0,4.4,3.6,8,8,8h56c4.4,0,8-3.6,8-8v-88l24-24V32l-81.9,81.9C61.1,122.9,56,135.1,56,147.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168,224c-8.8,0-16-7.2-16-16V32h208v176c0,8.8-7.2,16-16,16H168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,32v176c0,8.8,7.2,16,16,16h176c8.8,0,16-7.2,16-16V32H152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,320v-48c0-8.8,7.2-16,16-16h176c8.8,0,16,7.2,16,16v48H152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344,256H168c-8.8,0-16,7.2-16,16v48h208v-48C360,263.2,352.8,256,344,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168,224c-8.8,0-16-7.2-16-16l90.1-121.9L208,40l0.1-17.2c0.6-3.9,3.9-6.8,7.9-6.8h2.1L256,67.3L293.9,16h2.1 c3.9,0,7.3,2.9,7.9,6.8L304,40L168,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.9,22.8C303.3,19,300,16,296,16h-2.1L256,67.3L218.1,16H216c-4,0-7.3,2.9-7.9,6.8L208,40l34.1,46.1 L152,208c0,8.8,7.2,16,16,16L304,40L303.9,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.3,298.1c-2,0-3.9-0.7-5.3-2.1l-11.9-10.7c-1.6-1.5-2.5-3.4-2.7-5.5c-0.1-2.1,0.6-4.2,2.1-5.8l16.2-18 H168v-32h176v32h-49.5l16.2,18c2.9,3.4,2.7,8.3-0.6,11.3L298.2,296c-1.5,1.3-3.4,2-5.4,2c-2.3,0-4.4-0.9-5.9-2.6l-30.8-34.2 l-30.8,34.2C223.8,297.1,221.6,298.1,219.3,298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344,224H168v32h49.7l-16.2,18c-3,3.3-2.7,8.3,0.6,11.3L214,296c3.3,3,8.3,2.7,11.3-0.6l30.8-34.2l30.8,34.2 c3,3.3,8,3.5,11.3,0.6l11.9-10.7c3.3-3,3.5-8,0.6-11.3l-16.2-18H344V224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "248,256 232,240 248,224 264,224 280,240 264,256  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M264,256h-16c-6.2-6.2-9.8-9.8-16-16l0,0c6.2-6.2,9.8-9.8,16-16h16c6.2,6.2,9.8,9.8,16,16l0,0 C273.8,246.2,270.2,249.8,264,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "218.1,16 293.9,16 256,67.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "218.1,16 293.9,16 256,67.3  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructor);
export default __webpack_public_path__ + "static/media/Instructor.39920e4cd0a2fb749ac0db6a3482d5e9.svg";
export { ForwardRef as ReactComponent };